import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/app/global-error.tsx");
